import classNames from "classnames";
import { useFormik } from "formik";
import React from "react";
import { basePath } from "../config";
import { useOrderDetails } from "../../contexts/orderDetails";
import { OrderType } from "../../enums";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/auth";
import { IoMdAddCircle } from "react-icons/io";

const validate = (values, isPaperOrder, isBarcodeOrder) => {
  const errors = {};
  if (isPaperOrder) return {};

  if (!values.gap) {
    errors.gap = "Required";
  }
  if (!values.cut) {
    errors.cut = "Required";
  }
  if (!values.teeth) {
    errors.teeth = "Required";
  }
  if (!values.type) {
    errors.type = "Required";
  }
  if (!values.paper_size) {
    errors.paper_size = "Required";
  }

  return errors;
};

//add  data
async function doSubmit(
  values,
  formik,
  activeUser,
  orderDetails,
  setOrderDetails
) {
  try {
    const res = await fetch(basePath + "srartOrder", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${activeUser?.remember_token}`,
      },
      body: JSON.stringify({ ...values, id: orderDetails.id }),
    });

    console.log({ orderDetails });
    const data = await res.json();
    if (res.status === 401) {
      formik.resetForm({ values: values });
      document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      toast.error(data.message);
      return 0;
    }

    if (data.status) {
      setOrderDetails(JSON.parse(data.data));
      toast.success(data.message);
      formik.resetForm();
    } else {
      // TODO:: handle form while API fails
      // setOrders(null)
      formik.resetForm({ values: values });
      toast.error("error: " + data.message);
      console.error("error: " + data.message);
    }
  } catch (error) {
    // TODO:: handle form while API fails
    formik.resetForm({ values: values });
    toast.error("error: " + error);
    console.error("srartOrder:: api calling fail =>", error);
  }
}

export default function StartOrderForm() {
  const [
    { orderDetails, paperSizes },
    { setOrderDetails, setPaperSizeFormOpen },
  ] = useOrderDetails();
  const isPaperOrder = orderDetails?.order_type == OrderType.Paper;
  const isBarcodeOrder = orderDetails?.order_type === OrderType.Barcode;

  const [{ activeUser }] = useAuth();

  // console.log({orderDetails});
  const { gap, cut, teeth, type } = orderDetails;

  const formik = useFormik({
    initialValues: {
      gap: gap,
      cut: cut,
      teeth: teeth,
      type: type,
      paper_size: "",
    },
    validate: (values) => validate(values, isPaperOrder, isBarcodeOrder),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) =>
      doSubmit(values, formik, activeUser, orderDetails, setOrderDetails),
  });

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        {!isPaperOrder && (
          <div className="mt-2 grid grid-cols-6 gap-4">
            <div>
              <label className="block">
                <span className="block text-sm font-medium text-slate-700 capitalize">
                  Gap
                </span>
                <input
                  type="text"
                  name="gap"
                  disabled={false}
                  onChange={formik.handleChange}
                  value={formik.values.gap}
                  className={classNames(
                    "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                    formik.errors?.gap && "border-red-600"
                  )}
                />
              </label>
              {formik.errors.gap ? (
                <span className="text-sm text-red-600">
                  {formik.errors?.gap}
                </span>
              ) : null}
            </div>

            <div>
              <label className="block">
                <span className="block text-sm font-medium text-slate-700 capitalize">
                  Cut
                </span>
                <input
                  type="text"
                  name="cut"
                  disabled={false}
                  onChange={formik.handleChange}
                  value={formik.values.cut}
                  className={classNames(
                    "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                    formik.errors?.cut && "border-red-600"
                  )}
                />
              </label>
              {formik.errors.cut ? (
                <span className="text-sm text-red-600">
                  {formik.errors?.cut}
                </span>
              ) : null}
            </div>

            <div>
              <label className="block">
                <span className="block text-sm font-medium text-slate-700 capitalize">
                  Teeth
                </span>
                <input
                  type="text"
                  name="teeth"
                  disabled={false}
                  onChange={formik.handleChange}
                  value={formik.values.teeth}
                  className={classNames(
                    "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                    formik.errors?.teeth && "border-red-600"
                  )}
                />
              </label>
              {formik.errors.teeth ? (
                <span className="text-sm text-red-600">
                  {formik.errors?.teeth}
                </span>
              ) : null}
            </div>

            <div>
              <label className="block">
                <span className="block text-sm font-medium text-slate-700 capitalize">
                  Type
                </span>
                <input
                  type="text"
                  name="type"
                  disabled={false}
                  onChange={formik.handleChange}
                  value={formik.values.type}
                  className={classNames(
                    "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                    formik.errors?.type && "border-red-600"
                  )}
                />
              </label>
              {formik.errors.type ? (
                <span className="text-sm text-red-600">
                  {formik.errors?.type}
                </span>
              ) : null}
            </div>

            <div>
              <label className="block">
                <span className="block text-sm font-medium text-slate-700 capitalize">
                  paper size
                </span>
                <input
                  type="text"
                  name="paper_size"
                  disabled={false}
                  onChange={formik.handleChange}
                  value={formik.values.paper_size}
                  className={classNames(
                    "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                    formik.errors?.paper_size && "border-red-600"
                  )}
                />
              </label>

              {formik.errors.paper_size ? (
                <span className="text-sm text-red-600">
                  {formik.errors?.paper_size}
                </span>
              ) : null}
            </div>
          </div>
        )}

        <div className="mt-4 flex justify-start gap-3">
          <button
            type="submit"
            disabled={formik.isSubmitting}
            className={classNames(
              "inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2",
              formik.isSubmitting && "disabled:bg-slate-300"
            )}
          >
            Start Order
          </button>
        </div>
      </form>
    </div>
  );
}
